export const findApiV4Link = ({ofObject, withRel}) => {
  const links = ofObject.links || [],
    link = links.find(link => link.rel === withRel)
  return link && link.href
}
